module.exports = __webpack_public_path__ + "img/itunes.af11b3e1.png";